"use client";

import createIcon from './util/createIcon';
export default createIcon('M3,3H11V7.34L16.66,1.69L22.31,7.34L16.66,13H21V21H13V13H16.66L11,7.34V11H3V3M3,13H11V21H3V13Z', 'Widgets');